import _ from "lodash";
import dashboardConstants from "./dashboardConstants";
import { call } from "../../service";
export default {
  namespaced: true,
  state: {
    loading: false,
    state: { loading: false },
    links: [
      {
        to: "/dashboard/summary",
        order: 1,
        icon: "mdi-gauge",
        title: "Dashboard",
        disabled: false,
      },
    ],
    actions: [],
    menus: [],
    companies: [],
    studentProgrammes: [],
    intakePeriods: [],
    balance: "",
    amountToPay: "",
    accreditedInstitute: [],
    examCenters: [],
    settings: {},
  },
  mutations: {
    SET_LOADING: (state, payload) => {
      state.loading = payload;
    },
    SET_COMPANIES: (state, payload) => {
      state.companies = payload;
    },
    SET_SET_MENU: (state, payload) => {
      if (_.findIndex(state.menu, payload) === -1) {
        state.menus.push(payload);
      }
    },
    SET_LINKS: (state, payload) => {
      if (_.findIndex(state.links, payload) === -1) {
        state.links.push(payload);
      }
    },
    SET_ACTIONS: (state, payload) => {
      if (_.findIndex(state.actions, payload) === -1) {
        state.actions.push(payload);
      }
    },
    SET_STUDENT_PROGRAMMES: (state, payload) => {
      state.studentProgrammes = payload;
    },
    SET_INTAKE_PERIOD: (state, payload) => {
      state.intakePeriods = payload;
    },
    SET_BALANCE: (state, payload) => {
      state.balance = payload;
    },
    SET_AMOUNT_TO_PAY: (state, payload) => {
      state.amountToPay = payload;
    },
    SET_ACCREDITED_INSTITUTE: (state, payload) => {
      state.accreditedInstitute = payload;
    },
    SET_EXAM_CENTERS: (state, payload) => {
      state.examCenters = payload;
    },
    SET_SETTINGS: (state, payload) => {
      state.settings = payload;
    },
  },

  getters: {
    loading: (state) => state.loading,
    actions: (state) => state.actions,
    menus: (state) => state.menus,
    companies: (state) => state.companies,
    links: (state) => {
      return _.orderBy(state.links, (link) => link.order);
    },
    studentProgrammes: (state) => state.studentProgrammes,
    currentProgramme: (state) =>
      state.studentProgrammes.filter((p) => p.current),
    intakePeriods: (state) => state.intakePeriods,
    balance: (state) => state.balance,
    amountToPay: (state) => state.amountToPay,
    accreditedInstitute: (state) => state.accreditedInstitute,
    examCenters: (state) => state.examCenters,
    settings: (state) => state.settings,
  },

  actions: {
    resetPassword: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", dashboardConstants.password, data)
        .then(() => {
          Event.$emit("ApiSuccess", "Password Updated");
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },

    getStudentProgrammes: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", dashboardConstants.getRegistrations).then((res) => {
        commit("SET_STUDENT_PROGRAMMES", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },

    getCompanies: ({ commit }) => {
      call("get", dashboardConstants.companies)
        .then((res) => {
          commit("SET_COMPANIES", res.data.data);
        })
        .catch((err) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },

    saveSettings: ({ commit, dispatch }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", dashboardConstants.notification, data)
        .then(() => {
          Event.$emit("ApiSuccess", "Settings changed");
          commit("Dashboard/SET_LOADING", false, { root: true });
          dispatch("Auth/user", null, { root: true });
        })
        .catch((err) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },

    getIntakePeriods: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", dashboardConstants.intakePeriods).then((res) => {
        commit("SET_INTAKE_PERIOD", res.data.data);
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },

    getBalance: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", dashboardConstants.balance(payload)).then((res) => {
        commit("SET_BALANCE", res.data.data.shift());
        commit("Dashboard/SET_LOADING", false, { root: true });
      });
    },

    getStudentAmountToPay: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", dashboardConstants.getStudentAmountToPay(payload)).then(
        (res) => {
          commit("SET_AMOUNT_TO_PAY", res.data.data);
          commit("Dashboard/SET_LOADING", false, { root: true });
        },
      );
    },

    getaccreditedInstitute({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", dashboardConstants.ACCREDITEDINSTITUTE)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("SET_ACCREDITED_INSTITUTE", res.data.data);
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },

    getExamCenters({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", dashboardConstants.examCenters)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("SET_EXAM_CENTERS", res.data.data);
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },

    getSettings: ({ commit }) => {
      call("get", dashboardConstants.settings)
        .then((res) => {
          commit("SET_SETTINGS", res.data.data);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
